/**
 * Dashboard module store — list of submissions for the dashboard table
 * plus loading/error status. `policyDetailRow` is the row the user
 * clicked through to view on /order-details.
 */
class DashboardStore {
  #listeners = new Set();

  #dashboardSubmissions = [];
  #dashboardSubmissionsLoading = false;
  #dashboardSubmissionsError = null;
  #policyDetailRow = null;

  get dashboardSubmissions() { return this.#dashboardSubmissions; }
  set dashboardSubmissions(v) { this.#dashboardSubmissions = v; this.#notify(); }

  get dashboardSubmissionsLoading() { return this.#dashboardSubmissionsLoading; }
  set dashboardSubmissionsLoading(v) { this.#dashboardSubmissionsLoading = !!v; this.#notify(); }

  get dashboardSubmissionsError() { return this.#dashboardSubmissionsError; }
  set dashboardSubmissionsError(v) { this.#dashboardSubmissionsError = v; this.#notify(); }

  get policyDetailRow() { return this.#policyDetailRow; }
  set policyDetailRow(v) { this.#policyDetailRow = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#dashboardSubmissions = [];
    this.#dashboardSubmissionsLoading = false;
    this.#dashboardSubmissionsError = null;
    this.#policyDetailRow = null;
    this.#notify();
  }
}

const dashboardStore = new DashboardStore();
export default dashboardStore;
